import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center py-20 px-4">
      <div className="w-20 h-20 rounded-full bg-background-200 flex items-center justify-center mb-5">
        <i className={`${icon} text-4xl text-foreground-400`} />
      </div>
      <p className="font-heading font-bold text-lg text-foreground-800">{title}</p>
      {description && (
        <p className="text-sm text-foreground-500 mt-2 max-w-md">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}